"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeWidthHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../../events/general");
var sizing_1 = require("../../../_staging/layout/sizing");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
var layout_1 = require("../../store/layout");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var layoutValidation_1 = require("./validation/layoutValidation");
var layout_2 = require("../../events/layout");
var config_1 = require("../../../_staging/dashboard/fluidLayout/config");
function validateLayoutIndexes(ctx, layout, command) {
    var _a = command.payload, sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex;
    if (!layoutValidation_1.validateSectionExists(layout, sectionIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, command, "Attempting to resize item from non-existent section at " + sectionIndex + ". There are only " + layout.sections.length + " sections.");
    }
    var fromSection = layout.sections[sectionIndex];
    if (!layoutValidation_1.validateItemExists(fromSection, itemIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, command, "Attempting to resize non-existent item from index " + itemIndex + " in section " + sectionIndex + ". There are only " + fromSection.items.length + " items in this section.");
    }
}
function resizeWidthHandler(ctx, cmd) {
    var _a, sectionIndex, itemIndex, width, layout, insightsMap;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex, width = _a.width;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                layout = _b.sent();
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightsMap)];
            case 2:
                insightsMap = _b.sent();
                validateLayoutIndexes(ctx, layout, cmd);
                validateWidth(ctx, layout, insightsMap, cmd);
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.changeItemWidth({
                        sectionIndex: sectionIndex,
                        itemIndex: itemIndex,
                        width: width,
                    }))];
            case 3:
                _b.sent();
                return [2 /*return*/, layout_2.layoutSectionItemWidthResized(ctx, sectionIndex, itemIndex, width, cmd.correlationId)];
        }
    });
}
exports.resizeWidthHandler = resizeWidthHandler;
function validateWidth(ctx, layout, insightsMap, cmd) {
    var _a = cmd.payload, sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex, width = _a.width;
    var widget = layout.sections[sectionIndex].items[itemIndex].widget;
    var minLimit = sizing_1.getMinWidth(widget, insightsMap);
    var maxLimit = config_1.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT;
    var validHeight = width >= minLimit && width <= maxLimit;
    if (!validHeight) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to set invalid width. Allowed width is from " + minLimit + " to " + maxLimit + ".");
    }
}
//# sourceMappingURL=resizeWidthHandler.js.map